module.exports = __webpack_public_path__ + "img/icon15.5aaf76fc.png";